(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .component('sc3GameTrackerPutting', {
            templateUrl: 'app/game-tracker/putting/game-tracker-putting.component.html',
            controller: GameTrackerPuttingComponent,
            bindings: {
                data: '<'
            }
        });

    var gettext = angular.identity;

    GameTrackerPuttingComponent.$inject = ['$filter', 'gameTrackerChartFactory', 'gettextCatalog'];
    function GameTrackerPuttingComponent($filter, gameTrackerChartFactory, gettextCatalog) {
        var ctrl = this;
        ctrl.chart = null;
        ctrl.$onInit = init;

        ///////////////////////////////////////////////////////////

        function init() {
            var dateFilter = $filter('date');

            ctrl.chart = ctrl.data.details.reduce(reduce, {
                data: [
                    [],
                    []
                ],
                labels: [],
                series: [

                    gettextCatalog.getString(gettext('Putts Per Round')),
                    gettextCatalog.getString(gettext('Differential'))
                ],
                options: {
                    scales: {
                        xAxes: [{
                            ticks: { display: false },
                            gridLines: { display: false }
                        }]
                    },
                    elements: {
                        line: {
                            fill: false
                        }
                    },
                    legend: {
                        display: true,
                        position: 'bottom'
                    }
                },

            });

            function reduce(acc, item) {
                acc.data[0].push(item.putts);
                acc.data[1].push(item.differential);
                acc.labels.push(dateFilter(item.date, 'shortDate'));
                return acc;
            }
        }
    }
})();